<template>
  <div class="dashboard-guarantor-allowrance-block" v-if="guarantorLoaded">
    <Tabs class="" :animated="false" style="height:100%">
      <TabPane label="额度信息" name="allowance">
        <div class="tab-content" :style="{height:tabContentHeight+'px'}">
          <vue-scroll>
            <Row :gutter="16">
              <i-col span="24">
                <i-circle
                  :size="300"
                  :trail-width="4"
                  :stroke-width="5"
                  :percent="getAvaliablePercent"
                  style="margin: auto"
                  stroke-linecap="square"
                  stroke-color="#43a3fb">
                  <div class="balance-circle">
                    <h1>{{Math.round(calcBalance/10000)/100}}万</h1>
                    <p>已用额度</p>
                    <span>
                      占比
                      <i>{{getAvaliablePercent}}%</i>
                    </span>
                    <p>总额度:{{Math.round($store.getters.guarantorInfo.allowance/10000)/100}}万</p>
                  </div>
                </i-circle>
              </i-col>
              <!-- <i-col span="12">
                <Form label-position="right" :label-width="120">
                  <FormItem label="总额度">
                    <span>{{Math.round($store.getters.guarantorInfo.allowance/10000)/100}}万</span>
                  </FormItem>
                  <FormItem label="已用额度">
                    <span>{{Math.round(calcBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateMyCalculatedBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                  <FormItem label="在保笔数">
                    <span>{{undergoingCount}}</span>
                  </FormItem>
                  <FormItem label="在保担保额度">
                    <span>{{Math.round(undergoingBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateMyUndergoingBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                  <FormItem label="累计笔数">
                    <span>{{cumulativeCount}}</span>
                  </FormItem>
                  <FormItem label="累计担保额度">
                    <span>{{Math.round(cumulativeBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateMyCumulativeBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                </Form>
              </i-col> -->
            </Row>
          </vue-scroll>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      tabContentHeight: null,
      calcBalance: null,
      calcCount: null,
      cumulativeBalance: null,
      cumulativeCount: null,
      undergoingBalance: null,
      undergoingCount: null,
    }
  },
  computed: {
    guarantorLoaded () {
      return this.$store.getters.guarantorInfo
        && this.$store.getters.guarantorInfo.name
    },
    getAvaliablePercent () {
      if (!this.$store.getters.guarantorInfo.allowance || !this.calcBalance) {
        return 0
      }
      return Math.round((this.calcBalance / this.$store.getters.guarantorInfo.allowance) * 10000) / 100
    }
  },
  watch: {
    '$store.getters.guarantorInfo': function (newVal) {
      if (newVal && newVal.name) {
        this.guarantorModel = newVal
      }
    },
    '$store.getters.screenHeight': function () {
      this.calcTabContentHeight()
    },
    '$store.getters.screenWidth': function () {
      this.calcTabContentHeight()
    }
  },
  mounted () {
    if (this.$store.getters.guarantorInfo && this.$store.getters.guarantorInfo.name) {
      this.getMyBalance()
      this.calcTabContentHeight()
    }
  },
  methods: {
    calcTabContentHeight () {
      if (!document.querySelector('.dashboard-guarantor-allowrance-block')) {
        return false
      }
      let blockHeight = document.querySelector('.dashboard-guarantor-allowrance-block').clientHeight
      this.tabContentHeight = blockHeight - 36 - 16 // 减去ivu-tab-bar高度和margin
      // console.log(blockHeight, this.tabContentHeight)
    },
    getMyBalance () {
      this.$Api.Guarantee.getCalculatedBalance(this.$store.getters.guarantorInfo.id, null, null)
      .then((res) => {
        this.calcBalance = res.amount
        this.calcCount = res.count
      })
      this.$Api.Guarantee.getCumulativeBalance(this.$store.getters.guarantorInfo.id, null, null)
      .then((res) => {
        this.cumulativeBalance = res.amount
        this.cumulativeCount = res.count
      })
      this.$Api.Guarantee.getUndergoingBalance(this.$store.getters.guarantorInfo.id, null, null)
      .then((res) => {
        this.undergoingBalance = res.amount
        this.undergoingCount = res.count
      })
    },
    updateMyCalculatedBalance () {
      this.calcBalance = 0
      this.calcCount = 0
      this.$Api.Guarantee.updateCalculatedBalance(this.$store.getters.guarantorInfo.id, null, null)
      .then((res) => {
        this.calcBalance = res.amount
        this.calcCount = res.count
      })
    },
    updateMyCumulativeBalance () {
      this.cumulativeBalance = 0
      this.cumulativeCount = 0
      this.$Api.Guarantee.updateCumulativeBalance(this.$store.getters.guarantorInfo.id, null, null)
      .then((res) => {
        this.cumulativeBalance = res.amount
        this.cumulativeCount = res.count
      })
    },
    updateMyUndergoingBalance () {
      this.undergoingBalance = 0
      this.undergoingCount = 0
      this.$Api.Guarantee.updateUndergoingBalance(this.$store.getters.guarantorInfo.id, null, null)
      .then((res) => {
        this.undergoingBalance = res.amount
        this.undergoingCount = res.count
      })
    },
  }
}
</script>

<style lang="less" scoped>
.tab-content {
  overflow: hidden;
}
.dashboard-guarantor-allowrance-block {
  position: relative;
  height: 100%;
}
.balance-circle{
  & h1{
    color: #3f414d;
    font-size: 28px;
    font-weight: normal;
  }
  & p{
    color: #657180;
    font-size: 14px;
    margin: 10px 0 15px;
  }
  & span{
    display: block;
    padding-top: 15px;
    color: #657180;
    font-size: 14px;
    &:before{
      content: '';
      display: block;
      width: 50px;
      height: 1px;
      margin: 0 auto;
      background: #e0e3e6;
      position: relative;
      top: -15px;
    };
  }
  & span i{
    font-style: normal;
    color: #3f414d;
  }
}
</style>